import './style.css';

export default function Footer() {
  return (
    <div className="footer">
      <p>
        Feito com ❤️ por <a href="https://www.beeks.com.br">beeks</a> | © 2026.
        Todos os direitos reservados
      </p>
    </div>
  );
}
